{
  "WALLBOARD": {
    "LOADING": "Φόρτωση ουρών τηλεφώνου...",
    "NO_QUEUES": "Δεν βρέθηκαν ουρές τηλεφώνου.",
    "NO_AGENTS": "Δεν υπάρχουν συνδεδεμένοι πράκτορες σε αυτή την ουρά.",
    "UNKNOWN_CALLER": "Άγνωστος Καλών",
    "STATUS": "Κατάσταση",
    "TIME": "Ώρα",
    "AGENT": "Πράκτορας",
    "EXTENSION": "Εσωτερικό",
    "READY": "Διαθέσιμοι Πράκτορες",
    "ON_CALL": "Πράκτορες σε Κλήση",
    "PAUSED": "Πράκτορες σε Διάλειμμα",
    "WAITING": "Κλήσεις σε αναμονή",
    "MISSED_CALLS": "Αναπάντητες κλήσεις",
    "HANDLED_CALLS": "Εξυπηρετημένες εισερχόμενες κλήσεις",
    "OUTBOUND_CALLS": "Εξυπηρετημένες εξερχόμενες κλήσεις",
    "AVAILABILITY": "Διαθεσιμότητα",
    "AVAILABILITY_TOOLTIP": "Ποσοστό εισερχόμενων κλήσεων που απαντήθηκαν από πράκτορες (κλήσεις που παραλήφθηκαν)",
    "AGENTS_COUNT": "({onCall} σε κλήση / {total} σύνολο)",
    "NO_AVAILABLE": "(κανείς συνδεδεμένος)",
    "WAITING_CALLERS_COUNT": "{count} σε αναμονή",
    "CALLER": "Καλών",
    "NUMBER": "Αριθμός",
    "WAIT_TIME": "Χρόνος Αναμονής",
    "ACTION": "Ενέργεια",
    "PICKUP_CALL": "Παραλαβή",
    "PICKUP_SUCCESS": "Το αίτημα παραλαβής κλήσης υποβλήθηκε με επιτυχία.",
    "PICKUP_ERROR": "Αποτυχία παραλαβής κλήσης. Παρακαλώ προσπαθήστε ξανά.",
    "PICKUP_DISABLED_TOOLTIP": "Δεν μπορείτε να παραλάβετε κλήση ενώ βρίσκεστε σε κλήση ή είστε εκτός σύνδεσης.",
    "CHAT_STATUS": {
      "NO_ACCESS": "Χωρίς πρόσβαση"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "Χωρίς πρόσβαση"
    }
  }
}
